angular.module('dashboard').controller('ChartDashboardCtrl',
    ['$scope', '$q', 'TransitionManager', 'MyChartService', 'DashboardService', 'PatientPortalStorageRepository',
        function ($scope, $q, TransitionManager, MyChartService, DashboardService, PatientPortalStorageRepository) {

            'use strict';

            $scope.loading = true;

            $scope.labs = null;
            $scope.myChart = {'Config': ''};

            var activePatientId = PatientPortalStorageRepository.getActivePatient().id;

            function getNewLabResults() {
                return MyChartService
                    .getNewLabResults(activePatientId)
                    .then(function (data) {
                        $scope.labs = data;
                    })
                    .catch(function (response) {
                        $scope.addHttpError(response);
                    });
            }

            function getMyChartConfig() {
                return MyChartService
                    .getMyChartConfig()
                    .then(function (config) {
                        $scope.myChart.Config = config;
                    });
            }

            $scope.load = function(tile) {
                $scope.tile = tile;

                loadPage();
            };

            function loadPage() {
                $scope.loading = true;
                $scope.removeHttpError();

                activePatientId = PatientPortalStorageRepository.getActivePatient().id;
                var labsPromise = getNewLabResults();
                var chartConfigPromise = getMyChartConfig();

                $q.all([labsPromise, chartConfigPromise]).then(function () {
                    $scope.loading = false;
                });
            }

            $scope.updateCollapseState = function updateCollapseState()
            {
                $scope.tile.IsCollapsed = !$scope.tile.IsCollapsed;
                DashboardService.setPatientDashboardTileState($scope.tile);
            };

            $scope.displayMyChartLabs = function displayMyChartLabs() {
                TransitionManager.transition({appRoute: $scope.myChart.Config.ViewLabResults.Route, opts: {id: activePatientId}});
            };
        }
    ]
);